import React from 'react';

import LoginForm from '../../components/generalComponents/LoginForm';
import Alert from '../../components/generalComponents/Alert';
import { isNudeDomain } from '../../utils/helpers';


const content2 =
    'We have sent instructions on how to reset your password to the email address we have on file. If you do not receive the email shortly, check your spam folder. If you still can\'t find the email, contact customer service for assistance.';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAlertVisible: false,
      isErrorVisible: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    if (localStorage.getItem('resetLinkSent')) {
      // show alert
      this.showAlert();
      localStorage.removeItem('resetLinkSent');
    }
  }

  showAlert = () => {
    this.setState({ isAlertVisible: true });
  };

  hideAlert = () => {
    this.setState({ isAlertVisible: false });
  };

  onSubmitted = (user) => {
    if (user.userDetails.account.anchor) {
      window.location.href = '/dashboard';
    } else {
      window.location.href = '/';
    }
  };

  onError = (err) => {
    if (err) {
      this.setState({
        isErrorVisible: true,
        errorMessage: err.message,
      });
    }
  };

  hideError = () => {
    this.setState({
      isErrorVisible: false,
      errorMessage: '',
    });
  };

  render() {
    const { isAlertVisible, isErrorVisible, errorMessage } = this.state;

    return (
      <div className="content flex-1 justify-center flex items-center">
        {isAlertVisible && (
          <Alert onClose={this.hideAlert}>{content2}</Alert>
        )}
        {isErrorVisible && (
          <Alert onClose={this.hideError}>{errorMessage}</Alert>
        )}
        <div className="container">
          <div className="row-r">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
              <div className="nakednews-form-container login-form">
                <div className="nakednews-form-title">
                  Login to NN
                </div>
                <LoginForm
                  onError={this.onError}
                  onSubmitted={this.onSubmitted}
                />
                <a
                  className="nakednews-form-link"
                  href="/account/password/new"
                >
                  Forgot your username or password?
                </a>
                <a
                  className="nakednews-form-link"
                  href={
                    isNudeDomain ? 'http://join.nudenews.com/track/MTAzMzY4MS4xMDAxMS4xMDU2LjM2ODEuMS4wLjAuMC4w/join' : '/account/purchase'
                  }
                >
                  Need an account?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPage;
